export enum Ext {
  Bpmn = ".bpmn",
  Csv = ".csv",
  CsvJson = ".csv.json",
  Js = ".js",
  Json = ".json",
  JsonJson = ".json.json",
  JsJson = ".js.json",
  Md = ".md",
  Py = ".py",
  PyJson = ".py.json",
  Rs = ".rs",
  RsJson = ".rs.json",
  Ts = ".ts",
  Txt = ".txt",
}
